export default ".title{\n\tfont-size: 20px;\n\tcolor: #000;\n\tmargin-bottom: 20px;\n}";